import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { NavigateService } from './../../services/navigate.service';
import { OrderService } from '../../services/order.service';
import { Order } from '../../models/order.model';
import { OrderDocument } from '../../models/order-document.model';
import { Subscription, empty, interval } from 'rxjs';

// import 'tinymce';
import { StatisticsService } from '../../services/statistics.service';
import { TimeService } from '../../services/time.service';
declare var tinymce: any;
@Component({
  selector: 'app-type-order-item',
  templateUrl: './type-order-item.component.html',
  styleUrls: ['./type-order-item.component.scss']
})
export class TypeOrderItemComponent
  implements OnInit, OnDestroy {
  private id: string;
  private line: number;
  order: Order;
  documents: OrderDocument[];
  subscription: Subscription;
  timeSubscription: Subscription;
  activeIndex: number;
  workDate: Date;
  isPastItem: boolean;
  constructor(
    private activatedRoute: ActivatedRoute,
    private orderService: OrderService,
    public navigate: NavigateService,
    private statisticsService: StatisticsService,
    private timeService: TimeService
  ) {
    tinymce.PluginManager.add('stylebuttons', function(editor, url) {
      ['pre', 'p', 'code', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].forEach(function(
        name
      ) {
        editor.ui.registry.addToggleButton('style-' + name, {
          tooltip: 'Cambiar ' + name,
          text: name.toUpperCase(),
          onAction: function (_) {
            editor.execCommand('mceToggleFormat', false, name);
          },
          onSetup: function (api) {
            editor.formatter.formatChanged(name, function (state) {
              api.setActive(state);
            });
          }
        });
      });
    });
  }

  ngOnInit() {
    this.activeIndex = 0;
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.line = +this.activatedRoute.snapshot.paramMap.get('line');
    this.orderService.itemType(this.id, this.line).subscribe(r => {
      this.order = r.order;
      this.timeSubscription = this.timeService.workDateSource$.subscribe(
        val => {
          this.workDate = val;
          this.isPastItem = !this.order.items[0].publishDates.some(
            v => v >= val
          );
          console.log(this.workDate);
        }
      );
      setTimeout(() => {
        this.activeIndex = 1;
        if (this.documents[0].status === 'I') {
          this.orderService
            .saveDocumentData(this.documents[0], this.documents[0].data[0])
            .subscribe(a => {
              this.documents[0].status = 'PD';
            });
        }
      }, 500);
      this.documents = r.documents.map(v => {
        v.isSaved = !(v.status === 'I' || v.status === 'PD');
        return v;
      });
    });
    this.subscription = interval(10000).subscribe();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  saveOrder(document: OrderDocument): void {
    this.orderService.saveDocument(document).subscribe(val => {
      if (val) {
        document.status = 'F';
        document.isSaved = true;
        this.statisticsService.refreshStatistics();
      }
    });
  }
  cancelSave(document: OrderDocument): void {
    this.orderService.cancelSaveDocument(document).subscribe(val => {
      if (val) {
        document.status = 'PD';
        document.isSaved = false;
        this.statisticsService.refreshStatistics();
      }
    });
  }

  onChangeTab(evt): void {
    this.activeIndex = evt.index + 1;
    if (this.documents[evt.index].status === 'I') {
      this.orderService
        .saveDocumentData(this.documents[evt.index], this.documents[evt.index].data[0])
        .subscribe(a => {
          this.documents[evt.index].status = 'PD';
        });
    }
  }
}
